import { ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import React, { FC } from 'react';
import { MdArrowDropDown as ArrowDropDownIcon } from '@react-icons/all-files/md/MdArrowDropDown';
import Button from 'src/components/Button';

interface Props {
  openDocument: (type?: 'technical' | 'orderForm') => void;
}

const DocumentButtons: FC<Props> = ({ openDocument }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleMenuItemClick = (type: 'technical' | 'orderForm') => {
    openDocument(type);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup variant='contained' color='primary' ref={anchorRef}>
        <Button onClick={() => openDocument()}>Documents</Button>
        <Button color='primary' onClick={handleToggle}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id='split-button-menu'>
                  <MenuItem onClick={() => handleMenuItemClick('orderForm')}>Bon de commande</MenuItem>

                  <MenuItem onClick={() => handleMenuItemClick('technical')}>Documents techniques</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default DocumentButtons;
